import { findTimeToConvert } from '@api/reports';
import {
  TimeToConvertResponse,
  TimeToConvertRow,
  TimeToConvertSummary,
} from '@interfaces/reports/timeToConvert';
import { PaymentConversionPeriod } from '@interfaces/reports/paymentConversion';
import { ReportFiltersInput, useReportRequest } from '../useReportRequest';

export const emptySummary: TimeToConvertSummary = {
  arrivals: 0,
  converted: 0,
  conversionRate: 0,
  convertedWithinHour: 0,
  withinHourRate: 0,
  convertedWithinDay: 0,
  withinDayRate: 0,
  medianSeconds: 0,
  averageSeconds: 0,
};

export const emptyResponse: TimeToConvertResponse = {
  summary: emptySummary,
  distribution: [],
  rows: [],
};

const normaliseRow = (row: Partial<TimeToConvertRow>): TimeToConvertRow => ({
  arrivals: 0,
  converted: 0,
  conversionRate: 0,
  convertedWithinHour: 0,
  withinHourRate: 0,
  convertedWithinDay: 0,
  withinDayRate: 0,
  ...row,
  period: row.period ?? '',
});

export function useTimeToConvert(
  filters: ReportFiltersInput,
  timeAggregationPeriod: PaymentConversionPeriod = 'MONTH',
) {
  const { data, isLoading, hasFailed } = useReportRequest<TimeToConvertResponse>(
    filters,
    timeAggregationPeriod,
    findTimeToConvert as any,
    emptyResponse,
    (payload) => ({
      summary: { ...emptySummary, ...(payload.summary ?? {}) },
      distribution: (payload.distribution ?? []).map((bucket) => ({
        bucket: bucket?.bucket ?? '',
        buyers: bucket?.buyers ?? 0,
        share: bucket?.share ?? 0,
      })),
      rows: (payload.rows ?? []).map(normaliseRow),
    }),
  );

  return {
    summary: data.summary,
    distribution: data.distribution,
    rows: data.rows,
    isLoading,
    hasFailed,
  };
}
